import { render, staticRenderFns } from "./ModalCatalogTree.vue?vue&type=template&id=3af69c80"
import script from "./ModalCatalogTree.vue?vue&type=script&lang=js"
export * from "./ModalCatalogTree.vue?vue&type=script&lang=js"
import style0 from "./ModalCatalogTree.vue?vue&type=style&index=0&id=3af69c80&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports